import { render, staticRenderFns } from "./SummaryView.vue?vue&type=template&id=c0da6260&scoped=true&"
import script from "./SummaryView.vue?vue&type=script&lang=ts&"
export * from "./SummaryView.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryView.vue?vue&type=style&index=0&id=c0da6260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0da6260",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VFlex,VRow,VSelect,VSubheader})
